import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { listenToCharts } from 'modules/charts';
import { Table } from 'antd';
import firebase from 'firebase';
import mixpanel from 'mixpanel-browser';
import escapeRegexp from 'escape-string-regexp';
import { TitleCell, ActionCell } from 'components/ListTableCells';
import ListFilter from 'components/ListFilter';

const filterFunctions = {
  all: () => true,
  mine: (obj, uid) => uid === obj.creator.uid,
  favorites: (obj, uid, favorites) => !!favorites[obj.key],
};

class ChartListContainer extends React.Component {
  state = {
    filter: 'all',
    searchText: '',
  };

  async componentDidMount() {
    if (!this.props.syncer) {
      this.props.dListenToCharts();
    }
  }

  onClickNewChart = e => {
    mixpanel.track('Created new chart');
    e.preventDefault();
    this.props.dPush('/charts/new');
  };

  onCopy = async key => {
    mixpanel.track('Copied chart', {
      id: key,
    });
    const oldRef = firebase
      .database()
      .ref('charts')
      .child(key);
    const newRef = firebase
      .database()
      .ref('charts')
      .push();
    await oldRef.once('value', async snap => {
      const old = snap.val();
      await newRef.set({
        ...old,
        key: newRef.key,
        creator: {
          uid: this.props.uid,
          email: this.props.email,
        },
        updatedAt: firebase.database.ServerValue.TIMESTAMP,
      });
      await firebase
        .database()
        .ref('users')
        .child(this.props.uid)
        .child('charts')
        .child(newRef.key)
        .set(true);
      this.props.dPush(`/charts/${newRef.key}`);
    });
  };

  onDelete = key => {
    mixpanel.track('Deleted chart');
    firebase
      .database()
      .ref()
      .update({
        [`charts/${key}`]: null,
        [`users/${this.props.uid}/charts/${key}`]: null,
        [`users/${this.props.uid}/favoriteCharts/${key}`]: null,
      });
  };

  onFavorite = key => {
    const { favoriteCharts, uid } = this.props;
    const updated = !favoriteCharts[key];
    return firebase
      .database()
      .ref('users')
      .child(uid)
      .child('favoriteCharts')
      .child(key)
      .set(updated);
  };

  onSetPublic = async key => {
    const chart = this.props.charts.find(c => c.key === key);
    return firebase
      .database()
      .ref('charts')
      .child(key)
      .child('isPublic')
      .set(!chart.isPublic);
  };

  render() {
    const { charts, uid, favoriteCharts } = this.props;
    const { filter, searchText } = this.state;
    const searchRegexes = searchText
      .split(' ')
      .map(s => new RegExp(escapeRegexp(s), 'gi'));
    const dataSource = charts
      .filter(c => filterFunctions[filter](c, uid, favoriteCharts))
      .filter(chart =>
        searchRegexes.reduce((p, c) => p && chart.title.match(c), true)
      )
      .map(chart => ({
        key: chart.key,
        title: chart.title,
        creator: chart.creator,
        updatedAt: chart.updatedAt,
        isPublic: chart.isPublic,
      }));
    const columns = [
      {
        title: 'TITLE',
        dataIndex: 'title',
        render: (title, { key }) => (
          <TitleCell title={title} route={`/charts/${key}`} />
        ),
        sorter: (a, b) => a.title.localeCompare(b.title),
      },
      {
        title: 'CREATOR',
        key: 'creator',
        dataIndex: 'creator.email',
        sorter: (a, b) => a.creator.email.localeCompare(b.creator.email),
      },
      {
        title: 'ACTIONS',
        render: (title, row) => (
          <ActionCell
            id={row.key}
            onCopy={this.onCopy}
            onDelete={this.onDelete}
            uid={uid}
            creatorUid={row.creator.uid}
            favorite={!!favoriteCharts[row.key]}
            onFavorite={this.onFavorite}
            isPublic={row.isPublic || false}
            onSetPublic={this.onSetPublic}
          />
        ),
      },
    ];
    return (
      <div>
        <h1>CHART LIST</h1>
        <ListFilter
          filter={filter}
          onChange={f => this.setState({ filter: f })}
          searchText={searchText}
          onChangeSearch={t =>
            this.setState({
              searchText: t,
            })
          }
          onCreate={this.onClickNewChart}
          createText={'CREATE NEW CHART'}
        />
        <div
          style={{
            background: 'white',
            marginLeft: '-16px',
            marginRight: '-16px',
            marginTop: '25px',
          }}
        >
          <Table
            pagination={false}
            rowClassName={(_, index) => {
              if (index % 2 === 1) {
                return 'table-odd';
              }
              return null;
            }}
            columns={columns}
            dataSource={dataSource}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  uid: state.auth.uid,
  email: state.auth.email,
  favoriteCharts: state.auth.favoriteCharts,
  charts: state.charts.charts,
  syncer: state.charts.syncer,
});

const mapDispatchToProps = dispatch => ({
  dPush: route => dispatch(push(route)),
  dListenToCharts: () => dispatch(listenToCharts()),
});

ChartListContainer.propTypes = {
  uid: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  charts: PropTypes.array,
  syncer: PropTypes.bool.isRequired,
  dListenToCharts: PropTypes.func.isRequired,
  dPush: PropTypes.func.isRequired,
  favoriteCharts: PropTypes.object,
};

ChartListContainer.defaultProps = {
  charts: [],
  favoriteCharts: {},
};

export default connect(mapStateToProps, mapDispatchToProps)(ChartListContainer);



// WEBPACK FOOTER //
// ./src/containers/ChartListContainer.js